import React from "react";

export default function Contact() {
  return (
    <div>
      <h1>Estamos en la página Contact</h1>
    </div>
  );
}
